import PropTypes from 'prop-types'
import React from 'react'

import {
  ContainerTopMetaData,
  MetaText,
  Value,
  MetaRightBottom
} from '../../styled-components'

import { IsLoading } from '../list-items-item'

const CenterContainerMeta = ({
  meta,
  textRightValue,
  metaRightBottom,
  style
}) => {
  const { color } = style

  return (
    <ContainerTopMetaData>
      {meta && (
        <IsLoading skeletonStyle={{ width: '50px' }}>
          <MetaText colorTheme={color}>{meta}</MetaText>
        </IsLoading>
      )}
      {textRightValue && (
        <IsLoading skeletonStyle={{ width: '75px' }}>
          <Value colorTheme={color}>{textRightValue}</Value>
        </IsLoading>
      )}
      {metaRightBottom && (
        <IsLoading skeletonStyle={{ width: '75px' }}>
          <MetaRightBottom colorTheme={color}>
            {metaRightBottom}
          </MetaRightBottom>
        </IsLoading>
      )}
    </ContainerTopMetaData>
  )
}

CenterContainerMeta.propTypes = {
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  metaRightBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textRightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.object
}

export default CenterContainerMeta
